import { ConfigProviderPropsExtended } from "@/types/antd";

import { ConfigProvider } from "antd";

export const ConfigProviderExtended =
  ConfigProvider as React.FC<ConfigProviderPropsExtended>;
